import { render, staticRenderFns } from "./DateWiseReport.vue?vue&type=template&id=5226f421&"
import script from "./DateWiseReport.vue?vue&type=script&lang=js&"
export * from "./DateWiseReport.vue?vue&type=script&lang=js&"
import style0 from "./DateWiseReport.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports